import {
  CHANGE_GLOBAL_STATE,
  CHANGE_ERROR_DATA,
  CHANGE_LOADING_DATA,
  SET_IND_VALIDACION,
  SHOW_MODAL_LOADING,
  SET_VIEW_MODAL_ERROR,
  SET_RELATIONSHIP_LIST,
  SET_PAYMENT_SUBSCRIBED,
  SET_IS_FIRST_TIME_VIEWING_PLANS,
} from "../types/global";
import { UIStateMachine, StateMachine } from "../../utils/consts";

const initialState = {
  state: StateMachine[0],
  loadingData: {
    state: UIStateMachine[0],
    message: "",
  },
  errorData: {},
  indValidacion: {
    indPoliza: false,
    indYellowList: false,
    indCumulos: false,
    indBlackList: false,
  },
  modalLoading: "",
  viewModalError: false,
  relationshipList: [],
  isPaymentSuscribed: false,
  isFirstTimeViewingPlans: true,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_GLOBAL_STATE:
      return {
        ...state,
        state: action.payload,
      };
    case CHANGE_LOADING_DATA:
      return {
        ...state,
        loadingData: { ...action.payload },
      };
    case CHANGE_ERROR_DATA:
      return {
        ...state,
        errorData: action.payload,
      };
    case SET_IND_VALIDACION:
      return {
        ...state,
        indValidacion: action.payload,
      };
    case SHOW_MODAL_LOADING:
      return {
        ...state,
        modalLoading: action.payload,
      };
    case SET_VIEW_MODAL_ERROR:
      return {
        ...state,
        viewModalError: action.payload,
      };
    case SET_RELATIONSHIP_LIST:
      return {
        ...state,
        relationshipList: action.payload,
      };
    case SET_PAYMENT_SUBSCRIBED:
      return {
        ...state,
        isPaymentSuscribed: action.payload,
      };
    case SET_IS_FIRST_TIME_VIEWING_PLANS:
      return {
        ...state,
        isFirstTimeViewingPlans: action.payload,
      };
    default:
      return state;
  }
};
